const MOBILE_UA =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

export const isMobileDevice = () =>
  typeof navigator !== "undefined" && MOBILE_UA.test(navigator.userAgent);

export const canUseWebShare = () =>
  isMobileDevice() && typeof navigator.share === "function";
